import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Main = () => {
    document.title = "Əsas";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Göstəricilər", value: "/dashboard" },
        { name: "Əsas", value: "/dashboard/main", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Əsas</h2>
                    <p>
                        Ümumi qrafik şəklində olan və müxtəlif hesabatların göstəricilərinin əks olunduğu səhifədir. Günlük olan satışlar, satışlardan olan
                        gəlir, günlük pul mədaxil-məxarici, borclar, komisyon satışlar (səyyar satışlar) və sifarişlər bir paneldə əks olunur. Sahibkarın ümumi
                        kapitalı qrafik şəklində əks olunur. (Anbar qalığı + balans + borclar), həmçinin satış nöqtələri və hesabda olan balans qrafik şəkildə
                        göstərilir. Satış qrafikində isə aylıq satışın diaqramması göstərilir.
                    </p>
                    <img src="/images/dashboard/main.gif" alt="Əsas" />
                </article>
            </div>
        </div>
    );
};
